import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FramesActions } from '../../../../actions';
import { BoxTitle, Box } from '../../../PageTemplate';
import { Input, Select } from '../../../Form';
import { Validation, ConvertFromToPixel, PrintPage} from '../../../../helper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faExclamationTriangle} from '@fortawesome/fontawesome-free-solid';
import './print.scss';

const {REACT_APP_SAVE_ON_CHANGE_TIMEOUT} = process.env;

const A4_DEFAULT = {
    width: 2480,
    height: 3508,
    dpi: 300
}

class Print extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventFinised: false,
            eventID: null,
            frames: null,
            pageSizeIsCustom: false,
            actualFramesPerPage: false,
            framesPerPage: "",
            actualFramesPerPageIsOk: true, // actual frames per page is equal to frame.framesPerPage field
            converterPageSize: {
                to: 'cm',
                width: null,
                height: null,
                dpi: A4_DEFAULT.dpi
            },
            error: {
                x: false,
                y: false,
                pageWidth: false,
                pageHeight: false,
                dpi: false,
                framesPerPage: false
            }
        }

        this.updateTimeoutID = null;

        this.handleChange = this.handleChange.bind(this);
        this.handleUpdateSubmit = this.updateFrame.bind(this);
        this.handleSelectPageSize = this.handleSelectPageSize.bind(this);
        this.handleSelectPageSizeConverter = this.handleSelectPageSizeConverter.bind(this);
        this.updateFrameTimeout = this.updateFrameTimeout.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised} = props;
        const frames = props.frames.list;
        const eventID = props.events.currentEventID;
        const newState = {};

        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;

        // if frame deleted
        if(frames && !frames[eventID] && state.frames && state.frames.length > 0 && state.frames[0].eventID === eventID) {
            newState.frames = null;
        }

        // only if frames change
        if(frames && JSON.stringify(frames[eventID]) !== JSON.stringify(state.frames)) {
            newState.frames = frames[eventID];
            
            const frame = newState.frames && newState.frames[0];
            if(frame && state.framesPerPage.length === 0) newState.framesPerPage = frame.framesPerPage;
            
            // get acutal frames per page
            if(frame && frame.size && frame.page) {
                const pageImages = new PrintPage({
                    images: [],
                    frameSize: {
                        width: frame.size.x,
                        height: frame.size.y
                    },
                    page: frame.page
                });

                newState.actualFramesPerPage = pageImages.imagesPerPage;
                newState.actualFramesPerPageIsOk = pageImages.imagesPerPage === frame.framesPerPage;
            }
    
        }

        if(Object.keys(newState).length > 0) return newState;
        return null;
    }

    componentDidUpdate() {
        const {frames, pageSizeIsCustom, converterPageSize} = this.state;
        if(!frames) return false;
        const {page} = this.state.frames[0];

        // if page size is not equal to A4 size
        // and page sizeIsCustom still not true (prevent infinity loop)
        if(!pageSizeIsCustom && (page.width !== A4_DEFAULT.width || page.height !== A4_DEFAULT.height)) {
            const newConverter = {...converterPageSize};

            const calc = new ConvertFromToPixel({
                width: page.width,
                height: page.height,
                dpi: page.dpi,
                from: 'px',
                to: converterPageSize.to
            }).calculate();

            newConverter.width = calc.width.toFixed(1);
            newConverter.height = calc.height.toFixed(1);
            newConverter.dpi = page.dpi;

            this.setState({
                pageSizeIsCustom: true,
                converterPageSize: newConverter
            });
        }
    }

    handleChange(event) {
        const newState = {...this.state};

        (async () => {
            switch(event.target.name) {
                case 'x':
                    newState.frames[0].size.x = event.target.value;
                    break;
                case 'y':
                    newState.frames[0].size.y = event.target.value;
                    break;
                case 'framesPerPage':
                    newState.frames[0].framesPerPage = event.target.value;
                    newState.framesPerPage = event.target.value;
    
                    if(!isNaN(newState.framesPerPage) && Number(newState.framesPerPage) > 0) {
                        // get original frame dimensions 
                        // for clean frame size calculation of server side frame size algorithm
                        const dimensions = await this.getOriginalFrameDimensions(newState.frames[0].url);
                        newState.frames[0].size.x = dimensions.naturalWidth;
                        newState.frames[0].size.y = dimensions.naturalHeight;
                    }
    
                    break;
                case 'page.width':
                    newState.converterPageSize.width = event.target.value;
                    break;
                case 'page.height':
                    newState.converterPageSize.height = event.target.value;
                    break;
                case 'dpi':
                    newState.converterPageSize.dpi = event.target.value;
                    break;
                default: 
                    break;
            }
    
            this.setState(newState, this.updateFrameTimeout);
        })();
    }
    
    validatetion() {
        const invalidNum = (num) =>  !!!num || num < 0;
        const {size, page, framesPerPage} = this.state.frames[0];

        const err = {
            x: !Validation.onlyNumbers(size.x) || invalidNum(size.x),
            y: !Validation.onlyNumbers(size.y) || invalidNum(size.y),
            pageWidth: !Validation.onlyNumbers(page.width) || invalidNum(page.width),
            pageHeight: !Validation.onlyNumbers(page.height) || invalidNum(page.height),
            dpi: !Validation.onlyNumbers(page.dpi) || invalidNum(page.dpi),
            framesPerPage: !Validation.onlyNumbersNotFloat(framesPerPage) || invalidNum(framesPerPage) || framesPerPage > 100 || Number(framesPerPage) === 0
        }

        this.setState({error: {...this.state.error, ...err}});
        return !err.x && !err.y && !err.pageWidth && !err.pageHeight && !err.dpi && !err.framesPerPage;
    }

    convertToPx() {
        if(!this.state.pageSizeIsCustom) return false;
        const {to, width, height, dpi} = this.state.converterPageSize;

        const newFrames = {...this.state.frames};

        const res = new ConvertFromToPixel({
            width: width,
            height: height,
            dpi: dpi,
            from: to,
            to: 'px',
            roundPx: true
        }).calculate();

        newFrames[0].page = {
            width: res.width,
            height: res.height,
            dpi: dpi
        };

        this.setState({frames: newFrames});
    }

    /**
     * intended for update once per input change 
     * prevent multiple update while user change the input
     */
    updateFrameTimeout() {
        clearTimeout(this.updateTimeoutID);

        this.updateTimeoutID = setTimeout(this.updateFrame.bind(this), REACT_APP_SAVE_ON_CHANGE_TIMEOUT);
    }

    updateFrame() {
        const {dispatch} = this.props;
        
        this.convertToPx(); // notice: this method update state data

        const {frames, eventFinised, eventID} = this.state;

        const currentFrame = frames[0];
        if(currentFrame && currentFrame._id && this.validatetion() && !eventFinised) {

            const data = {
                size: {...currentFrame.size},
                page: {...currentFrame.page},
                framesPerPage: currentFrame.framesPerPage
            }

            dispatch(FramesActions.updateFrame(eventID, currentFrame._id, data));
        }
    }

    handleSelectPageSize(e) {
        const newFrames = {...this.state.frames};
        const converter = {...this.state.converterPageSize}
        
        switch(e.target.value) {
            case 'custom':
                this.setState({pageSizeIsCustom: true});
            break;
            case 'a4': 
            default:
                newFrames[0].page = {
                    width: A4_DEFAULT.width,
                    height: A4_DEFAULT.height,
                    dpi: A4_DEFAULT.dpi
                }

                converter.width = "";
                converter.height = "";
                converter.dpi = A4_DEFAULT.dpi;

                this.setState({frames: newFrames, pageSizeIsCustom: false, converterPageSize: converter}, this.updateFrame);
                break;
        }
    }

    handleSelectPageSizeConverter(e) {
        const converter = {...this.state.converterPageSize};
        converter.to = e.target.value;

        this.setState({converterPageSize: converter}, this.updateFrame);
    }

    getSizeFromPx(width, height) {
        const {frames, converterPageSize} = this.state;
        if(!frames || !frames[0]) return;

        const calc = new ConvertFromToPixel({
            width: width,
            height: height,
            dpi: frames[0].page.dpi,
            from: 'px',
            to: converterPageSize.to
        }).calculate();

        return {
            width: calc.width.toFixed(1),
            height: calc.height.toFixed(1)
        }
    }

    getOriginalFrameDimensions(url) {
        return new Promise((resolve, rejects) => {
            const img = new Image();
            img.onload = (e) => {
                resolve(img);
            }

            img.src = url;
        });  
    }

    render() {
        const {frames, actualFramesPerPage, actualFramesPerPageIsOk, framesPerPage} = this.state;
        const updateInProcess = this.props.frames.updateFrameProcess;
        const frame = frames && frames[0];
        let x = frame && frame.size.x;
        let y = frame && frame.size.y;

        if(x && y) {
            const {width, height} = this.getSizeFromPx(x, y);
            x = width;
            y = height;
        }

        return (
            <Box col="1" id="printFrameSettings">
                <BoxTitle icon="faPrint">
                    הדפסה
                </BoxTitle>
                <div className={`${frame ? `hide` : ''}`}>
                    נדרש להוסיף מסגרת למגנט כדי לערוך הגדרות אלו
                </div>
                <div className={`details ${!frame ? `hide` : ''}`}>
                    <div className="inputRow">
                        יחידת מידה
                        <Select label={true} onChange={this.handleSelectPageSizeConverter} value={this.state.converterPageSize.to}>
                            <option value="cm">Cm</option>
                            <option value="inch">Inch</option>
                        </Select>
                    </div>
                    <div className="inputRow inputSpace">
                        <Input
                            name="x"
                            value={x || ""}
                            placeholder="רוחב המסגרת"
                            error={this.state.error.x}
                            errorText={`שדה לא תקין`}
                            onChange={this.handleChange}
                            label={true}
                            type="number"
                            disabled={true}
                        />
                        <Input
                            name="y"
                            value={y || ""}
                            placeholder="אורך המסגרת"
                            error={this.state.error.y}
                            errorText={`שדה לא תקין`}
                            onChange={this.handleChange}
                            label={true}
                            type="number"
                            disabled={true}
                        />
                    </div>
                    
                    <div className="inputRow">
                        סוג הדף
                        <Select label={true} onChange={this.handleSelectPageSize} value={this.state.pageSizeIsCustom ? 'custom' : 'a4'} disabled={this.state.eventFinised}>
                            <option value='a4'>
                                A4
                            </option>
                            <option value='custom'>
                                מותאם אישית
                            </option>
                        </Select>
                    </div>
                    <div className={`inputRow inputSpace${!this.state.pageSizeIsCustom ? ' hide': ''}`}>
                        <Input
                            name="page.width"
                            value={this.state.converterPageSize.width || ""}
                            placeholder="רוחב הדף"
                            error={this.state.error.pageWidth}
                            errorText={`שדה לא תקין`}
                            onChange={this.handleChange}
                            label={true}
                            type="number"
                            disabled={this.state.eventFinised}
                        />
                        <Input
                            name="page.height"
                            value={this.state.converterPageSize.height || ""}
                            placeholder="אורך הדף"
                            error={this.state.error.pageHeight}
                            errorText={`שדה לא תקין`}
                            onChange={this.handleChange}
                            label={true}
                            type="number"
                            disabled={this.state.eventFinised}
                        />

                        <Input
                            name="dpi"
                            value={this.state.converterPageSize.dpi || ""}
                            placeholder="dpi"
                            error={this.state.error.dpi}
                            errorText={`שדה לא תקין`}
                            onChange={this.handleChange}
                            label={true}
                            type="number"
                            disabled={this.state.eventFinised}
                        />
                    </div>
                    <div className="inputRow">
                        <Input 
                            name="framesPerPage"
                            value={framesPerPage || ""}
                            onChange={this.handleChange}
                            placeholder="מספר מגנטים בדף"
                            label={true}
                            error={this.state.error.framesPerPage}
                            errorText={`שדה לא תקין`}
                            type="number"
                            disabled={this.state.eventFinised}
                        />
                    </div>
                    <div className={`inputRow error ${actualFramesPerPageIsOk || updateInProcess ? 'hide': ''}`}>
                        <FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;
                        מספר התמונות שיודפסו בפועל בדף הוא: {actualFramesPerPage}
                    </div>
                </div>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        frames: state.framesReducer
    }
}

const PrintWithRedux = connect(mapStateToProps)(Print);

export {PrintWithRedux as Print};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/frame/Print.jsx